import React, { FC, useRef, useState, useEffect } from "react";
import styles from "./collective.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CollectiveSlider: FC = () => {
  const sliderRef = useRef<Slider>(null);

  const imagePaths = [
    "/assets/images/home/collective/brand=ccwn.svg",
    "/assets/images/home/collective/brand=chungTai.svg",
    "/assets/images/home/collective/brand=cleanaway.svg",
    "/assets/images/home/collective/brand=dachuang.svg",
    "/assets/images/home/collective/brand=homegi.svg",
    "/assets/images/home/collective/brand=lyuYing.svg",
    "/assets/images/home/collective/brand=SinoPac.svg",
    "/assets/images/home/collective/brand=top-comment.svg",
  ];

  const next = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const previous = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
      />
    );
  }
  const [rwdBtn, setRwdBtn] = useState(false);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [slidesToScroll, setSlidesToScroll] = useState(3);
  const [width, setwidth] = useState("");

  const handleResize = () => {

    if (window.innerWidth < 576) {
      setSlidesToScroll(2);
      setSlidesToShow(2);
      setwidth("350px");
    } else if (window.innerWidth < 768){
       setwidth("500px");
    }
    
    else if (window.innerWidth < 1200) {
      setSlidesToScroll(2);
      setSlidesToShow(3);
      setwidth("76%");
    } else if (window.innerWidth < 1400) {
      setwidth("86%");
    } else {
      setSlidesToScroll(4);
      setSlidesToShow(4);
      setwidth("74%");
    }

    if (window.innerWidth < 992) {
        setRwdBtn(true);
    } else {
        setRwdBtn(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    dotsClass: "slick-dots",
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          rows: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          rows: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          rows: 2,
        },
      },
    ],
  };
  return (
    <div className={styles["slider_container"]}>
      <div className={`slider_box  `}>
        {rwdBtn === false && (
            <button className="preBtn" onClick={previous}>
            <img src="/assets/images/slider/blueArrow_L.png" alt="arrow_L" />
          </button>
        )}
        
        <div className="slider" style={{ width: width }}>
          <Slider ref={sliderRef} {...settings}>
            {imagePaths.map((path, index) => (
              <img
                key={index}
                src={process.env.PUBLIC_URL + path}
                alt={`Brand ${index}`}
                style={{ maxWidth: "220px", minWidth: "220px" }}
              />
            ))}
          </Slider>
        </div>
        {rwdBtn === false && (
            <button className="nextBtn" onClick={next}>
            <img src="/assets/images/slider/blueArrow_R.png" alt="arrow_R" />
          </button>
        )}
        
      </div>
      {rwdBtn === true && (
        <div className="RWD_silder_arrow">
        <button className="preBtn" onClick={previous}>
          <img src="/assets/images/slider/blueArrow_L.png" alt="arrow_L" />
        </button>
        <button className="nextBtn" onClick={next}>
          <img src="/assets/images/slider/blueArrow_R.png" alt="arrow_R" />
        </button>
      </div>
      )}
      
    </div>
  );
};

export default CollectiveSlider;
